import { useContextGuard } from '../../../../models/hooks/useContextGuard';
import * as React from 'react';

export interface IEditCampaignTemplateContext {
	displayName?: string;
	setDisplayName?(displayName?: string | ((currentDisplayName?: string) => string)): void;
}

export const EditCampaignTemplateContext = React.createContext<IEditCampaignTemplateContext>({});

export const useEditCampaignTemplateContext = () =>
	useContextGuard(EditCampaignTemplateContext, 'EditCampaignTemplateContext');

export interface IEditCampaignTemplateContextProps {
	editCampaignTemplateContext?: IEditCampaignTemplateContext;
}

export const withEditCampaignTemplateContext = <P extends IEditCampaignTemplateContextProps>(
	WrappedComponent: React.ComponentType<P>
): React.ComponentType<P> => {
	const Wrapper: React.FC<P> = props => {
		return (
			<EditCampaignTemplateContext.Consumer>
				{context => <WrappedComponent editCampaignTemplateContext={context} {...props} />}
			</EditCampaignTemplateContext.Consumer>
		);
	};
	return Wrapper;
};
